// eslint-disable-next-line import/no-anonymous-default-export
export default {
	// "zh": {
	// 	"join_now": "加入",
	// },
	"en": {
		"sign_up": "Sign Up",
		"select": "Select",
		"competition_genre": "Current competition Genre",
		"world": "World",
		"model": "Model",
		"step_1": "Step 1: Contact Information",
		"step_2": "Step 2: Select",
		"facebook": "Facebook",
		"submit": "Submit",
		"confirm": "Confirm",
		"max_of_9": "You can only choose 9 pieces of work to participate in the competition.",
		"confirm_upload": "Are you certain that you want to upload? It cannot be re-uploaded once it has been posted as a contribution.",
		"cancel": "Cancel",
		"other": "Other",
		"one_submission_only": "*One submission only.Take your time and give us your best.",
		"published_after": "Only works published during the contest period are eligible for judging.",
		"enter_whatsApp": "Enter your WhatsApp account",
		"enter_facebook": "Enter your Facebook account",
		"enter_other": "Enter your account",
		"registered_success": "You have successfully registered!",
		"not_origial": "The work you selected does not meet the criteria.",
	},
	"in": {
		"sign_up": "Daftar",
		"select": "Pilih",
		"competition_genre": "Genre kompetisi saat ini",
		"world": "Dunia",
		"model": "Model",
		"step_1": "Langkah 1: Informasi Kontak",
		"step_2": "Langkah 2: Pilih",
		"facebook": "Facebook",
		"submit": "Kirim",
		"confirm": "Mengonfirmasi",
		"max_of_9": "Anda hanya dapat memilih 9 karya untuk berpartisipasi dalam kompetisi.",
		"confirm_upload": "Apakah Anda yakin ingin mengunggah? Karya tidak dapat diunggah ulang setelah diposting sebagai kontribusi.",
		"cancel": "Batal",
		"other": "Lain",
		"one_submission_only": "*Hanya bisa daftarkan 1 kali saja. Harap pastikan karya yang didaftarkan sudah benar.",
		"published_after": "Hanya karya yang dirilis selama periode event akan dinilai.",
		"enter_whatsApp": "Masukkan  *(WhatsApp) akun Anda",
		"enter_facebook": "Masukkan  *(Facebook) akun Anda",
		"enter_other": "Masukkan akun Anda",
		"registered_success": "Anda telah berhasil mendaftar!",
		"not_origial": "Karya yang kamu pilih tidak memenuhi kriteria.",
	},
	"pt": {
		"sign_up": "Inscrever-se",
		"select": "Selecionar",
		"competition_genre": "Tipo da competição atual",
		"world": "Mundo",
		"model": "Modelo",
		"step_1": "Passo 1: informações de contato",
		"step_2": "Passo 2: Selecionar",
		"facebook": "Facebook",
		"submit": "Enviar",
		"confirm": "Confirmar",
		"max_of_9": "Você só pode escolher 9 partes do trabalho para participar dessa competição",
		"confirm_upload": "Você tem certeza de que deseja carregar? Não poderá ser carregado novamente uma vez que for postado como uma contribuição ",
		"cancel": "Cancelar",
		"other": "Outros",
		"one_submission_only": "Apenas uma submissão. Não se apresse e nos dê o seu melhor.",
		"published_after": "Apenas trabalhos publicados durante o período do concurso são elegíveis para serem julgados.",
		"enter_whatsApp": "Insira a sua conta *(WhatsApp)",
		"enter_facebook": "Insira a sua conta *(Facebook)",
		"enter_other": "Insira a sua conta",
		"registered_success": "Você foi registrado com sucesso!",
		"not_origial": "O trabalho seleciona não está de acordo com o critério.",
	}
}














































